import { ChangeSubscriptionOptions } from "@/types/localtypes";

export const DOWNGRADE: ChangeSubscriptionOptions = "downgrade";
export const CANCEL: ChangeSubscriptionOptions = "cancel";
export const SELF_DOWNGRADE_TO_FREE: ChangeSubscriptionOptions = "self_downgrade_to_free";
export const REMOVE_SECURITY_PACK: ChangeSubscriptionOptions = "remove_security_pack";
